module.exports = __webpack_public_path__ + "static/media/total@2x.54197114.png";